import { createSelector } from 'reselect';

import { selectStore } from './store';

export const selectInviteAppIsOpen = createSelector(
  selectStore,
  (state) => state.isInviteAppOpen
);
